import React, { Component } from 'react'
import { connect } from 'react-redux'

import { AccessRightRecord } from '../../../../../../services/authorization/reducer'

function mapStateToProps(state) {
    const modules = state.getIn(['authorization', 'accessRights'], new AccessRightRecord())
    const activeModules = modules
        .toSeq()
        .toList()
        .sortBy((m) => m.get('order'))
        .filter((m) => m.get('available'))

    return {
        modules: activeModules,
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
